import FollowersColumn from '../components/FollowersColumn'

const Home = () => {
  return (
    <div className="container">
        <FollowersColumn />
        <div className="feed">
            <h1>Home page title change</h1>
        </div>
        <div className="suggested-box">
            <h1>Suggested Box Change test</h1>
        </div>
    </div>
  );
}

export default Home;
